import { useState, Dispatch } from "react";
import { useRacehorse360Api } from "hooks/api";
import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import * as queries from "./queries";

interface TrainerAutoComplete {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
  options: racehorse360.ITrainer[];
  trainerName: string;
  setTrainerName: Dispatch<React.SetStateAction<string>>;
}

export function useTrainerAutocompleteState(): TrainerAutoComplete {
  const [open, setOpen] = useState(false);
  const [trainerName, setTrainerName] = useState("");

  const { useListTrainers } = useRacehorse360Api();

  const { data: trainers, isLoading: trainersLoading } = useListTrainers(
    "TRAINER_SEARCH",
    queries.trainers(trainerName)
  );

  return {
    open,
    setOpen,
    loading: trainersLoading,
    options: trainers?.trainers || [],
    trainerName,
    setTrainerName
  };
}
